export const officialStatus = [
    'PLH', 
    'PLT', 
    'AKTIF'
]